import React, { Component } from 'react';
import Slide from 'react-reveal/Slide';
import axios from 'axios';
import Pagination from 'rc-pagination';
import { debounce } from 'lodash';
import { CSVLink } from 'react-csv';
import { Link as RouterLink } from 'react-router-dom';
import { env } from '../../../../shared/environment';
import 'rc-pagination/assets/index.css';
import IconMoreInfo from '../../../../components/icon/IconMoreInfo';
import Modal from '../../layouts/dashboard/Modal/Modal';
import Loading from '../dashboard/Loading.gif';
import './Applications.scss';

class Applications extends Component {
  isLoading = false;
  baseUrl = env.baseUrl;
  params = {
    full_name: '',
    phone: '',
    status: '',
    rows_limit: 10,
    rows_offset: 0,
  };

  headers = [
    { label: 'ID', key: 'id' },
    { label: 'ФИО', key: 'full_name' },
    { label: 'Номер телефона', key: 'phone' },
    // { label: 'Сумма долгов', key: 'amountOfDebts' },
    // { label: 'Ежемес. пог.', key: 'totalShouldPays' },
    // { label: 'Транши', key: 'countOfActiveTrenches' },
    // { label: 'Просрочки', key: 'countOfDelays' },
    { label: 'Причина', key: 'reason' },
    { label: 'Желаемый срок отсрочки', key: 'period' },
    // { label: 'Дата и время', key: 'date' },
    // { label: 'Статаус CRM', key: 'crmStatus' },
    { label: 'Статус', key: 'status' },
    // { label: 'Подтвержден', key: 'confirmed' },
    // { label: 'CRM link', key: 'crmLink' },
    // { label: 'ABS link', key: 'absLink' },
  ];
  applicationsCSV = [];

  constructor() {
    super();

    this.state = {
      full_name: '',
      phone: '',
      status: '',
      applications: [],
      loading: false,
      pageSize: 10,
      total: 0,
      current: 1,
      exportApplications: [],
      modalData: [],
      isTableRightShadow: true,
      isModalOpen: false,
    };

    this.getApplication = this.getApplication.bind(this);
    this.getApplicationCSV = this.getApplicationCSV.bind(this);
    this.onShowSizeChange = this.onShowSizeChange.bind(this);
    this.onChangeFullname = this.onChangeFullname.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    this.onPaginate = this.onPaginate.bind(this);
    this.search = this.search.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
  }

  componentDidMount() {
    axios
      .post(`${this.baseUrl}application`, this.params)
      .then((response) => {
        this.setState({
          applications: response.data.payload,
          total: response.data.info,
        });
        this.getApplicationCSV();
      })
      .catch(function (error) {
        console.log('err: ', error);
      });
  }

  handleScrollTable = (e) => {
    if (!e.target) return;
    if (e.target.scrollWidth === e.target.scrollLeft + e.target.clientWidth)
      this.setState({
        isTableRightShadow: false,
      });
    else
      this.setState({
        isTableRightShadow: true,
      });
  };

  handleOpenModal = () => {
    this.setState({
      isModalOpen: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  getApplication(params) {
    axios
      .post(`${this.baseUrl}application`, params)
      .then((response) => {
        this.setState({
          applications: response.data.payload,
        });
      })
      .catch(function (error) {
        console.log('err: ', error);
      });
  }

  getApplicationCSV() {
    const params = {
      rows_limit: this.state.total,
      rows_offset: 1,
    };

    axios
      .post(`${this.baseUrl}application`, params)
      .then((response) => {
        this.applicationsCSV = response.data.payload;

        // for (let i = 0; i < this.applicationsCSV.length; i++) {
        //   const element = this.applicationsCSV[i];
        //   this.applicationsCSV[i].absID = element.absLink
        //     .replace('https://core.alif.tj/core/clients/', '')
        //     .replace('http://core.alif.tj/core/clients/', '')
        //     .replace('/edit', '');
        // }

        this.setState({ exportApplications: this.applicationsCSV });
      })
      .catch(function (error) {
        console.log('err: ', error);
      });
  }

  onShowSizeChange(event) {
    this.setState({ pageSize: Number(event.target.value) });
    this.params.rows_limit = Number(event.target.value);
    this.params.rows_offset = 0;

    this.getApplication(this.params);
  }

  onChangeFullname(event) {
    this.setState({ full_name: event.target.value });
    this.params.full_name = event.target.value;
    this.params.rows_offset = 0;
    this.search();
  }

  onChangePhone(event) {
    this.setState({ phone: event.target.value });
    this.params.phone = event.target.value;
    this.params.rows_offset = 0;
    this.search();
  }

  onChangeStatus(event) {
    this.setState({ status: event.target.value });
    this.params.status = event.target.value;
    this.params.rows_offset = 0;
    this.search();
  }

  onPaginate(page) {
    this.setState({ current: page });
    this.params.rows_offset = (page - 1) * this.params.rows_limit;

    this.getApplication(this.params);
  }

  search = debounce(() => {
    axios
      .post(`${this.baseUrl}application`, this.params)
      .then((response) => {
        this.setState({
          applications: response.data.payload,
          total: response.data.info,
        });
      })
      .catch((error) => {
        console.log('err: ', error);
      });
  }, 400);

  updateStatus(id, status) {
    const params = {
      id: Number(id),
      status: status,
    };

    axios
      .put(`${this.baseUrl}application/update`, params)
      .then((response) => {
        if (response.data.code === 200) {
          this.setState({
            loading: true,
          });
          axios
            .post(`${this.baseUrl}application`, this.params)
            .then((data) => {
              console.log(this.state.loading);
              this.setState({
                applications: data.data.payload,
                loading: false,
              });
            })
            .catch((error) => {
              console.log('err: ', error);
            });
        }
      })
      .catch((error) => console.log('err: ', error));
  }

  handleRowClick = (id) => {
    axios
      .post(`https://muhlat.alif.tj/api/covidalif/v0/application/info`, {
        id,
      })

      .then((response) => {
        this.setState({
          modalData: response.data.payload,
        });
      })
      .catch((error) => {
        console.log('err: ', error);
      });
  };

  render() {
    const Link = ({ link }) => {
      return (
        <a href={link} className="link" download>
          ссылка
        </a>
      );
    };
    const applications =
      this.state.applications && this.state.applications.length > 0
        ? this.state.applications.map((application, index) => {
            let color = '';
            switch (application.status) {
              case 'new':
                color = 'btn-danger';
                break;
              case 'pending':
                color = 'btn-warning';
                break;
              case 'accepted':
                color = 'btn-success';
                break;
              case 'approved':
                color = 'btn-primary';
                break;
              case 'KK':
                color = 'btn-info';
                break;

              default:
                color = 'btn-secondary';
                break;
            }
            const userStatus = {
              consideration: 'РАССМАТРИВАЕТСЯ',
              approved: 'ОДОБРЕНО',
              checking: 'НА ПРОВЕРКУ',
              considered: 'РАССМОТРЕНО',
              denied: 'ОТКАЗАНО',
              processed: 'ОБРАБОТАН',
              received: 'ПРИНЯТО',
            };

            const allPayment = {
              false: 'Нет',
              true: 'Да',
            };

            return (
              <tr key={application.id}>
                <td>{application.id}</td>
                <td> {application.create_date} </td>
                <td>
                  {application.full_name} <br />
                </td>
                <td> {application.phone} </td>
                <td> {application.city_name} </td>
                <td>
                  {application.trench.split(',').join(', ')} <br />
                </td>
                <td>{application.trench_count}</td>
                <td>{allPayment[application.all_payments]}</td>
                <td>
                  <Link link={application.application_file_link} />
                </td>
                <td>
                  <Link link={application.confirmation_file_link} />{' '}
                </td>
                <td>{application.reason.split(',').join(', ')}</td>
                <td>{application.period}</td>
                <td>
                  <span className={`status-${application.status}`}>
                    {userStatus[application.status]}
                  </span>
                </td>
                <td
                  className="application-more-info-div"
                  onClick={() => this.handleRowClick(application.id)}
                >
                  {/* <RouterLink to={'/admin/applications/' + application.id}> */}
                  <div
                    onClick={this.handleOpenModal}
                    // onClick={() => this.handleRowClick(application.id)}
                    className="more-information"
                  >
                    <IconMoreInfo /> Подробно
                  </div>
                  {/* </RouterLink> */}
                </td>
              </tr>
            );
          })
        : '';

    return (
      <div className="row">
        {this.state.isModalOpen && (
          <Modal
            handleCloseModal={this.handleCloseModal}
            modalData={this.state.modalData}
          />
        )}
        <div className="col-12">
          <Slide top>
            <div className="row">
              <div className="col-12 mb-2">
                <div className="c-top">
                  <div className="c-body" style={{ height: '70px' }}>
                    <h4 className="float-left">ЗАЯВКИ</h4>
                    <CSVLink
                      className="btn btn-sm btn-info float-right"
                      filename={'applications.csv'}
                      data={this.state.exportApplications}
                      headers={this.headers}
                    >
                      Скачать в CSV
                    </CSVLink>
                  </div>
                </div>
              </div>
            </div>
            {this.state.loading ? (
              <div className="spinner-div">
                <div>
                  <img src={Loading} alt="" />
                </div>
              </div>
            ) : (
              <div className="c-bottom">
                <div
                  className="c-body borderLayer"
                  onScroll={this.handleScrollTable}
                >
                  {this.state.isTableRightShadow && (
                    <div className="linear-cover" />
                  )}
                  <div className="row">
                    <div className="col-4 mb-2">
                      <select
                        className="form-control form-control-sm float-left"
                        onChange={this.onShowSizeChange}
                        value={this.state.pageSize}
                        style={{ width: '80px' }}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                    <div className="col-8 mb-2">
                      <div>
                        <div
                          className="input-group float-right"
                          style={{ width: '600px' }}
                        >
                          {/* <input className="form-control form-control-sm" value={this.state.status} onChange={this.onChangeStatus} placeholder="Сатаус" /> */}
                          <select
                            className="form-control form-control-sm"
                            value={this.state.status}
                            onChange={this.onChangeStatus}
                          >
                            <option value="all">ВСЕ</option>
                            <option value="consideration">
                              РАССМАТРИВАЕТСЯ
                            </option>
                            <option value="approved">ОДОБРЕНО</option>
                            <option value="checking">НА ПРОВЕРКУ</option>
                            <option value="considered">РАССМОТРЕНО</option>
                            <option value="denied">ОТКАЗАНО</option>
                            <option value="processed">ОБРАБОТАН</option>
                            <option value="received">ПРИНЯТО</option>
                          </select>
                          <input
                            className="form-control form-control-sm"
                            value={this.state.phone}
                            onChange={this.onChangePhone}
                            placeholder="Телефон"
                          />
                          <input
                            className="form-control form-control-sm"
                            value={this.state.full_name}
                            onChange={this.onChangeFullname}
                            placeholder="ФИО"
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-sm btn-info"
                              onClick={this.search}
                            >
                              Поиск
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div style={{ overflow: 'scroll' }} className="col-12">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Дата и время</th>
                            <th>ФИО</th>
                            <th>Телефон</th>
                            <th>Город</th>
                            <th>Транш</th>
                            <th>Кол траншов</th>
                            <th>За текущий период</th>
                            <th>Документ заявление</th>
                            <th>Документ утверждение</th>
                            <th>Причина</th>
                            <th>Срок отсрочки</th>
                            <th>Статус</th>
                            <th>Информация</th>
                          </tr>
                        </thead>
                        <tbody>{applications}</tbody>
                      </table>
                      <Pagination
                        className="float-right"
                        pageSize={this.state.pageSize}
                        onShowSizeChange={this.onShowSizeChange}
                        onChange={this.onPaginate}
                        current={this.state.current}
                        showTotal={(total, range) =>
                          `${range[0]} - ${range[1]} of ${total}`
                        }
                        total={this.state.total}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Slide>
        </div>
      </div>
    );
  }
}

export default Applications;
